// @flow
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { attemptValidateToken, validateToken, attemptAcceptInvite, acceptInvite } from './actions';

const IS_TOKEN_INVALID = 'isTokenInvalid';
const IS_VALIDATING_TOKEN = 'isValidatingToken';
const IS_TOKEN_VALIDATION_COMPLETE = 'isTokenValidationComplete';
const IS_ACCEPTING_INVITE = 'isAcceptingToken';
const IS_TOKEN_ACCEPTED = 'isTokenAccepted';
const HAS_ERROR_ACCEPTING_TOKEN = 'hasErrorAcceptingToken';

export const initialState = fromJS({
    [IS_TOKEN_INVALID]: false,
    [IS_VALIDATING_TOKEN]: false,
    [IS_ACCEPTING_INVITE]: false,
    [IS_TOKEN_ACCEPTED]: false,
    [IS_TOKEN_VALIDATION_COMPLETE]: false,
    [HAS_ERROR_ACCEPTING_TOKEN]: false
});

const actionHandlers = new Map([
    [
        attemptValidateToken,
        handleReduce(state =>
            state.merge({
                [IS_TOKEN_INVALID]: false,
                [IS_VALIDATING_TOKEN]: true,
                [IS_TOKEN_VALIDATION_COMPLETE]: false
            })
        )
    ],
    [
        validateToken,
        handleReduce(
            state =>
                state.merge({
                    [IS_TOKEN_INVALID]: false,
                    [IS_VALIDATING_TOKEN]: false,
                    [IS_TOKEN_VALIDATION_COMPLETE]: true
                }),
            state =>
                state.merge({
                    [IS_TOKEN_INVALID]: true,
                    [IS_VALIDATING_TOKEN]: false,
                    [IS_TOKEN_VALIDATION_COMPLETE]: true
                })
        )
    ],
    [
        attemptAcceptInvite,
        handleReduce(state =>
            state.withMutations(state => state.set(IS_ACCEPTING_INVITE, true).set(HAS_ERROR_ACCEPTING_TOKEN, false))
        )
    ],
    [
        acceptInvite,
        handleReduce(
            state => state.withMutations(state => state.set(IS_TOKEN_ACCEPTED, true).set(IS_ACCEPTING_INVITE, false)),
            state => {
                return state.withMutations(state =>
                    state
                        .set(IS_TOKEN_ACCEPTED, false)
                        .set(IS_ACCEPTING_INVITE, false)
                        .set(HAS_ERROR_ACCEPTING_TOKEN, true)
                );
            }
        )
    ]
]);

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/connected-care-invite/index.js